import { schema } from 'normalizr'

const sailPackageSchema = new schema.Entity('sailPackages', {}, { idAttribute: 'code' })

export const sailPackagesSchema = new schema.Array(sailPackageSchema)
